module.exports = __webpack_public_path__ + "static/media/TurkeyTrack.svg";